import React, { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FilledLoading from "../loader/FilledLoading";
import { getInvitationDetails } from "../../../store/reducers/invitationReducer";
import { InvDiv } from "../Style";
import Output from "./Output";
import Names from "./Names";
import Links from "./Links";
import Footer from "./Footer";
import Extra from "./Extra";
import GenericArivalConfirmation from "./GenericArivalConfirmation";
import { handleClickScroll } from "../others/Functions";
//
const Invitation = () => {
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { token } = useParams();
  const search = useLocation().search;

  const getId = (num) => {
    let name = new URLSearchParams(search).get("n");
    name = window.atob(name);
    name = name.split(" ");
    return name[num];
  };

  useEffect(() => {
    setLoading(true);
    dispatch(getInvitationDetails({ token })).then((res) => {
      setLoading(false);
      if (res.payload?.error) toast.error("חלה שגיאה, יש לנסות לרענן...");
      else setDetails(res.payload);
    });
  }, []);

  useEffect(() => {
    setTimeout(function () {
      handleClickScroll("bla");
    }, 2000);
  }, []);

  const borderedInvsStyle = {
    width: "100%",
    backgroundColor: "rgba(255,255,255,0.75)",
    boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
    padding: "6px",
    borderRadius: "16px",
    paddingBottom: "24px",
    border: "1px solid rgba(0,0,0,0.06)",
  };
  const basicDivStyle =
    details?.invK === 1 ? { width: "100%" } : borderedInvsStyle;

  return (
    <>
      {details ? (
        <InvDiv
          gradient={details.gradient}
          style={{
            width: "100%",
            height: `${window.screen.availHeight}px`,
            height: "100%",
            padding: details.invK === 1 ? "0" : "15px",
            // maxHeight: "800px",
            position: "relative",
          }}
        >
          <div style={{ ...basicDivStyle }}>
            <Output
              _id={details._id}
              pic={details.pic}
              picPosition={details.picPosition}
              cropAreaAspect={details.cropAreaAspect}
            />
            {/* {details.inv === 1 && (
              <Names data={details} heartColor={details.heartColor} />
            )} */}
            <Names data={details} heartColor={details.heartColor} />
            <GenericArivalConfirmation
              // gId={getId(1)}
              // uId={getId(0)}
              self={false}
              token={token}
              heartColor={details.heartColor}
              acceptLimit={details.acceptLimit}
              specialDishes={details.specialDishes}
              transportation={details.transportation}
              specialMsg={details.specialMsg}
              specialMsgDetails={details.specialMsgDetails}
              blessing={details.blessing}
              blessTitle={details.blessTitle}
              transportationDetails={details.transportationDetails}
              invK={details.invK}
              separation={details.separation}
              seuda={details.seuda}
            />
            {details.inv === 1 && <Extra data={details} />}
            <Links data={details} token={token} />
            {/* לעשות כמו בי סימפל */}
          </div>
          {/* <div style={{ height: "200px" }} /> */}
          <Footer producer={details.producer} />
          {loading && <FilledLoading />}
        </InvDiv>
      ) : (
        <FilledLoading />
      )}
    </>
  );
};

export default Invitation;
